export function urlToImage(image: string) {
  return image.includes('empty')
    ? `https://decathlonstore.vteximg.com.br${image}`
    : image
}
